<template>
  <div class="progress-bar" v-on:click="seekToPosition" ref="progressContainer">
    <div class="time">
      <span class="current">{{ completedTime }}</span>
      <span class="final">{{ track.length }}</span>
    </div>
    <div class="black-line"></div>
    <div class="completed" v-bind:style="{ width: completedWidth }"><div class="ball"></div></div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: ['soundcloud', 'track'],
  data: function () {
    return {
      time: 0
    }
  },
  computed: {
    completedWidth: function () {
      var newWidth = Math.floor(100000 * this.soundcloud.progress.relativePosition) / 1000
      return newWidth + '%'
    },
    completedTime: function () {
      if (!this.soundcloud.progress.currentPosition) {
        return '0:00'
      }
      var positionInSeconds = this.soundcloud.progress.currentPosition / 1000
      var minutes = Math.floor(positionInSeconds / 60)
      var seconds = Math.floor(positionInSeconds - 60 * minutes)
      var timeString = minutes.toString() + ':'
      if (seconds < 10) {
        timeString += '0' + seconds.toString()
      } else {
        timeString += seconds.toString()
      }
      return timeString
    }
  },
  methods: {
    seekToPosition: function (event) {
      var progressContainer = this.$refs.progressContainer
      var width = progressContainer.offsetWidth
      var rect = progressContainer.getBoundingClientRect()
      var position = event.clientX - rect.left + document.body.scrollLeft
      var percent = position / width
      var api = this.soundcloud.api
      this.soundcloud.api.getDuration().then(function (duration) {
        var newPosition = Math.floor(duration * percent)
        api.seekTo(newPosition)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ListenPage/ProgressBar.vue?49f82a7c